import { EnumsInterface } from "@/interfaces/EnumsInterface";

const PerpetratorIdentity:EnumsInterface[] = [
    {id: 0, value: 0, label: "Known"},
    {id: 1, value: 1, label: "Unknown"},
]

export default PerpetratorIdentity